import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	PromotePageLoginModalLoginByEmail,
	type PromotePageLoginModalLoginByEmailMutation,
	type PromotePageLoginModalLoginByEmailMutationVariables,
} from './loginByEmail.graphql';

export type LoginByEmailResult = PromotePageLoginModalLoginByEmailMutation['loginByEmail'];

export async function loginByEmail(
	input: PromotePageLoginModalLoginByEmailMutationVariables['input'],
	{ gql: { fetch } }: UtilityContext,
): Promise<PromotePageLoginModalLoginByEmailMutation['loginByEmail']> {
	const { data } = await fetch<
		PromotePageLoginModalLoginByEmailMutation,
		PromotePageLoginModalLoginByEmailMutationVariables
	>({
		path: '/login',
		query: PromotePageLoginModalLoginByEmail,
		variables: {
			input,
		},
		rejectOnError: true,
		batched: false, // to ensure this rate limited mutation is not batched
	});
	return data.loginByEmail;
}
